import { CopyButton } from '@/components/ui/CopyButton'
import { Dropzone } from '@/components/ui/dropzone'
import { cn } from '@/lib/utils'
import { Demo, DsSection } from '../primitives'

const noop = () => {}

const STATES: { prop: string; dropzone: React.ReactNode }[] = [
  { prop: '<Dropzone onChange={setFile} />', dropzone: <Dropzone onChange={noop} /> },
  {
    prop: 'accept=".pdf,.csv,.xlsx"',
    dropzone: <Dropzone onChange={noop} accept=".pdf,.csv,.xlsx" />,
  },
  { prop: 'showFileHints={false}', dropzone: <Dropzone onChange={noop} showFileHints={false} /> },
  {
    prop: 'multiple onMultipleChange={setFiles}',
    dropzone: <Dropzone multiple onMultipleChange={noop} />,
  },
  { prop: 'isLoading', dropzone: <Dropzone onChange={noop} isLoading /> },
  { prop: 'disabled', dropzone: <Dropzone onChange={noop} disabled /> },
]

function Labeled({
  value,
  onDark,
  children,
}: {
  value: string
  onDark?: boolean
  children: React.ReactNode
}) {
  return (
    <div className="flex w-full flex-col items-start gap-2">
      {children}
      <div
        className={cn(
          'flex items-center gap-1 font-mono text-[10px]',
          onDark ? 'text-ink-300' : 'text-ink-400'
        )}
      >
        <span>{value}</span>
        <CopyButton
          value={value}
          className={cn(
            'size-4 bg-transparent hover:bg-transparent',
            onDark ? 'text-ink-300 hover:text-white' : 'text-ink-400 hover:text-ink'
          )}
        />
      </div>
    </div>
  )
}

export function DropzoneSection() {
  return (
    <DsSection id="dropzone" title="Dropzone">
      <Demo label="States" className="grid gap-8 md:grid-cols-2">
        {STATES.map(({ prop, dropzone }) => (
          <Labeled key={prop} value={prop}>
            {dropzone}
          </Labeled>
        ))}
      </Demo>
      <Demo label="Extra content" className="grid gap-8 md:grid-cols-2">
        <Labeled value="children">
          <Dropzone onChange={noop}>
            <p className="text-ink-500 text-sm">The file should include each trailer’s VIN and year.</p>
          </Dropzone>
        </Labeled>
      </Demo>
      <Demo label="On dark" dark className="grid gap-8 md:grid-cols-2">
        <Labeled value="onDark" onDark>
          <Dropzone onChange={noop} onDark />
        </Labeled>
      </Demo>
    </DsSection>
  )
}
